<div class="modal fade in" id="roleEditModal" role="dialog">
    <div class="modal-dialog modal-lg" *ngIf="editableUserRole">
    <div class="modal-content">

        <div class="modal-header">
            <button type="button" class="close"  data-dismiss="modal" (click)="cancel()"><i class="fa fa-times" aria-hidden="true"></i></button>
            <h4 class="modal-title"><i class="fa fa-plus" aria-hidden="true"></i> ADD/UPDATE ROLE</h4>
        </div>

      <div class="modal-body">
        <div class="row">
          <div class="col-sm-2"><label class="labelRequired">NAME:</label></div>
          <div class="col-sm-5">
            <div class="form-group">
              <input type="text" class="form-control" [(ngModel)]="editableUserRole.name">
            </div>
          </div>
        </div>

        <div class="row">
            <div class="col-sm-2"><label class="labelRequired">DESCRIPTION:</label></div>
          <div class="col-sm-5"><div class="form-group">
            <textarea class="form-control" rows="1" [(ngModel)]="editableUserRole.description"></textarea>
          </div>
          </div>
        </div>

        <hr>

        <div class="row">
          <div class="col-sm-12">
            <ul class="nav nav-tabs">
              <li class="active">
                <a href="#groupPermission" data-toggle="tab">GROUPS</a>
              </li>
              <li>
                <a href="#pagePermission" data-toggle="tab">PAGES</a>
              </li>
            </ul>
            <div class="tab-content">
              <div id="groupPermission" class="tab-pane fade in active">
                <div class="add-op">
                  <div class="btn-group">
                    <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown"><i class="fa fa-plus" aria-hidden="true"></i> ADD GROUP</button>
                      <ul class="dropdown-menu role">
                        <ng-container *ngFor="let group of allGroups">
                          <ng-container *ngIf="!groupInRole(group)">
                            <li (click)="addGroupToUserRole(group)">{{ group.name }} ({{ group.type }})</li>
                          </ng-container>
                        </ng-container>
                      </ul>
                  </div>
                </div>

                <div class="panel dialog">
                  <div class="panel-body">
                    <div class="table-responsive table-role">
                      <table class="table table-hover" id="roleGroupTable">
                        <thead>
                        <tr>
                          <th class="table-checkbox">
                            <div class="checkbox checkbox-inline">
                              <input type="checkbox" id="selectAllGroups" />
                            </div>
                          </th>
                          <th>NAME</th>
                          <th>TYPE</th>
                          <th><i class="fa fa-plus"></i> CREATE</th>
                          <th><i class="fa fa-eye"></i> READ</th>
                          <th><i class="fa fa-pencil"></i> UPDATE</th>
                          <th><i class="fa fa-trash-o"></i> DELETE</th>
                        </tr>
                        </thead>
                        <tbody id="roleGroupTableBody" *ngIf="editableUserRole.groupPermissions && editableUserRole.groupPermissions.values">
                        <ng-container *ngFor="let groupValue of editableUserRole.groupPermissions.values; trackBy: indexTracker">
                          <tr><td><i class="fa fa-minus-circle minus" (click)='deleteGroupQuery(groupValue.group.id)'></i></td>
                            <td>{{ (groupValue.group.name) ? groupValue.group.name : "ALL" }}</td>
                            <td>{{ groupValue.group.type }} </td>
                            <td><div class="checkbox checkbox-inline"><input id="checkbox_create" type='checkbox' class="styled" [(ngModel)]="groupValue.permission.create"><label for="checkbox_create"></label></div></td>
                            <td><div class="checkbox checkbox-inline"><input id="checkbox_read" type='checkbox' class="styled" [(ngModel)]="groupValue.permission.read"><label for="checkbox_read"></label></div></td>
                            <td><div class="checkbox checkbox-inline"><input id="checkbox_update" type='checkbox' class="styled" [(ngModel)]="groupValue.permission.update"><label for="checkbox_update"></label></div></td>
                            <td><div class="checkbox checkbox-inline"><input id="checkbox_delete" type='checkbox' class="styled" [(ngModel)]="groupValue.permission.delete"><label for="checkbox_delete"></label></div></td>
                          </tr>
                        </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div id="pagePermission" class="tab-pane fade">
                <div class="panel">
                  <div class="panel-body panel-role">
                      <ul class="roleManagerPages" id="myUL">
                      <ng-container *ngFor="let pageName of pagePermissionKeys()">
                        <ng-container *ngIf="pagePermissionService.formattedName(pageName) != ''">
                            <li (click)="this.editableUserRole.pagePermissions[pageName].read = !this.editableUserRole.pagePermissions[pageName].read " [class.checked]="this.editableUserRole.pagePermissions[pageName].read">{{ pagePermissionService.formattedName(pageName) }}</li>
                        </ng-container>
                      </ng-container>
                      </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
      <div class="modal-footer">
          <button (click)="cancel()" class='btn btn-default'><i class="fa fa-ban" aria-hidden="true"></i> CANCEL</button>
          <button (click)="createOrUpdateRole()" class="btn btn-primary"><i class="fa fa-plus" aria-hidden="true"></i> ADD/UPDATE</button>
       </div>
    </div>

  </div>
</div>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>
